import {
  FaCalendarAlt,
  FaHourglassHalf,
  FaFire,
  FaMotorcycle,
} from 'react-icons/fa';

export const BackgroundColorMap = {
  AGENDAMENTO: '#8B72BE',
  ANDAMENTO: '#5290A8',
  PENDENTE: '#D4764E',
  ENTREGA: '#5D9B76',
};

export const StatusIconMap = {
  AGENDAMENTO: FaCalendarAlt,
  PENDENTE: FaHourglassHalf,
  ANDAMENTO: FaFire,
  ENTREGA: FaMotorcycle,
};

export const StatusDescriptionMap = {
  AGENDAMENTO: 'Programados para depois',
  PENDENTE: 'Aguardando confirmação',
  ANDAMENTO: 'Em preparo na cozinha',
  ENTREGA: 'Saiu para entrega',
};

export const frases = [
  'Novo pedido chegou!',
  'Pedido à espera!',
  'Alerta de pedido!',
  'Pedido novo na área!',
  'Pedido fresquinho!',
  'Mais um na fila!',
  'Cliente novo pediu!',
  'Chegou, equipe!',
  'Olho no pedido!',
  'Preparar novo prato!',
];

export const orderTypes = ['AGENDAMENTO', 'PENDENTE', 'ANDAMENTO', 'ENTREGA'];
